import script from "./ServiceCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceCard.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceCard.vue?vue&type=style&index=0&id=3ec49866&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ec49866"]])

export default __exports__